import PageHeader from 'src/components/page-header/page-header';

export default function InventoryHeader() {
  return <PageHeader title="Controle de Estoque" />;
}
